import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import Spinner from 'react-spinner-material'
import '../../../../styles/assets/css/admin/list2.css'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { yes_no, yes_no_notsure, primary_interest, gen_m } from '../../../patients/variables/registration.js'
import ViewAssessment from './view_assessment.js'

class Csi extends Component {
  constructor() {
      super();
      this.state = {
          dataItems: {},
          loading: false,
      }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/get_screen_questionnaire',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { pid: this.props.match.params.pid }
    })
    .then((result) => {
        this.setState({
          dataItems: result['data'],
          loading: true,
        })
      }
    )
  }

  findLabelByValue(arr, searchValue) {
    var label = ''
    var result = arr.find(obj => {
      return obj.value == searchValue
    })
    if(typeof result !== "undefined") {
      label = result.label
    }
    return label
  }

  render() {
    return (
      <div className="general_information">
      {!this.state.loading &&
        <div className="row">
          <div className="small-12 columns loading2">
            <Spinner color={"#bbbbbb"} radius={50}/>
          </div>
        </div>}
      {this.state.loading &&
        <div className="row">
          <div className="small-12 columns">
              <ViewAssessment pid={this.props.match.params.pid} assm='csi' time_type='r' timepoint='0' />
            </div>
      </div>}
      </div>
  )}
}

const mapStateToProps = (state) => {
  //console.log('PatientList STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('PatientList mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Csi)
